import React, { Component } from "react";
import { browserHistory } from "react-router";
import PropTypes from "prop-types";
import util from "../util/util";
import InaccessibleLink from "../shim/inaccessible-link";

const jQuery = window.jQuery;

const returnInitialState = props => {
  return {
    pod: props.pod,
    rule: props.rule
  };
};

export default class TimeslotPopover extends Component {
  constructor(props) {
    super(props);

    // create a unique ID so when the popover JS is applied;
    // this is the only target to init;
    this.id = `id-${(Math.random() * 1e64).toString(36)}`;

    this.state = returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;

    this.initPopover();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState(returnInitialState(nextProps), this.initPopover);
  }

  render() {
    return (
      <div>
        <InaccessibleLink className="timeslot-popover__trigger" id={this.id}>
          {this.state.pod.name}
        </InaccessibleLink>

        <div className="hidden">
          <div className="timeslot-popover">
            <div className="row">
              <div className="col-xs-6">
                <h4 className="page__header">Rule</h4>
                <p>
                  {this.state.rule ? (
                    <a href={util.returnRuleDetailUrl(this.state.rule.id)}>
                      {this.state.rule.name}
                    </a>
                  ) : null}
                </p>
              </div>
              <div className="col-xs-6">
                <h4 className="page__header">Source Pod</h4>
                <p>
                  {this.state.pod ? (
                    <a href={util.returnPodDetailUrl(this.state.pod.id)}>
                      {this.state.pod.name}
                    </a>
                  ) : null}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  initPopover() {
    const insertedEvent = `inserted.bs.popover`;
    const shownEvent = `shown.bs.popover`;
    const hideEvent = `hide.bs.popover`;
    const clickEvent = `click.popover`;
    const $body = jQuery(`body`);

    // define the link to trigger the popover;
    const $popoverTrigger = jQuery(`#${this.id}`);

    // init the Bootstrap popover for just this one instance;
    // the contents of the popover come from a hidden DIV;
    // then attach Bootstrap popover events to change the content once it is shown;
    $popoverTrigger
      .popover({
        container: `body`,
        content: () => $popoverTrigger.next().html(),
        html: true,
        placement: `auto`
      })
      .off(hideEvent)
      .on(hideEvent, () => {
        // remove the event bound to the body on show;
        $body.off(clickEvent);
      })
      .off(insertedEvent)
      .on(insertedEvent, () => {
        // once shown, change the links to be interactive;
        // it must be done this way (after the popover is created);
        // Bootstrap does not clone the events attached to the popover content, just the raw HTML;
        jQuery(`.popover a`).on(clickEvent, e => {
          const $a = jQuery(e.target);
          const to = $a.attr(`href`);

          e.preventDefault();

          browserHistory.push(to);
        });
      })
      .off(shownEvent)
      .on(shownEvent, () => {
        // add event to body to close this popover on click elsewhere;
        // but we can't have clicks from within the popover to trigger the closing;
        $body.off(clickEvent).on(clickEvent, e => {
          if (
            jQuery(e.target)
              .parents(`.popover`)
              .size() === 0
          ) {
            $popoverTrigger.trigger(clickEvent);
          }
        });
      });
  }
}

TimeslotPopover.propTypes = {
  pod: PropTypes.object,
  rule: PropTypes.object
};
